import { object, string } from 'yup';

export default object().shape({
  placa: string().required('* Campo obrigatório!'),
})
